import { render, staticRenderFns } from "./Prez.vue?vue&type=template&id=5a92b0ef"
var script = {}
import style0 from "./Prez.vue?vue&type=style&index=0&id=5a92b0ef&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports